"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CircularProgress.default;
  }
});

var _CircularProgress = _interopRequireDefault(require("./CircularProgress"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/CircularProgress/index.js
// module id = 44
// module chunks = 0